import React, { Component } from 'react'
import { Field, Form } from 'redux-form'
import Button from 'components/Button'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import NumbersAvailableTable from '../NumbersAvailableTable'
import CheckboxRow from 'components/Input/CheckboxRow'
import { vRequired } from 'components/Input/Input.validations'

export default class NumbersEnableFlowsForm extends Component {
  onSubmit = data => {
    const {
      afterSubmit,
      serviceId,
      createNumber,
      linkTwilioToAapt,
      ban,
      phoneNumber,
      getNumbers,
    } = this.props
    return createNumber({
      number: data.number,
      ban,
      usagePlanAlias: 'twilio-local',
      customerReference: `Flow Alias - ${phoneNumber}`,
    })
      .then(({ value: { data } }) => {
        if (data.service?.id) {
          linkTwilioToAapt({
            serviceIdAapt: serviceId,
            serviceIdTwilio: data.service.id,
          })
        }
      })
      .then(getNumbers)
      .then(afterSubmit)
  }

  render() {
    const { handleSubmit, formData, submitting, onCancel, phoneNumber, change } = this.props
    return (
      <Form onSubmit={handleSubmit(this.onSubmit)} style={{ position: 'relative' }}>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          By enabling Call Flows you get 1 free local number. This will be an alias for{' '}
          {phoneNumber}. Please select or search for your free local number:
        </div>
        <NumbersAvailableTable
          country="AU"
          type="local"
          formData={formData}
          value={formData.number}
          onSelect={service => {
            change('number', service.phoneNumber)
          }}
        />
        <Field
          name="confirmFees"
          component={CheckboxRow}
          style={{ margin: '30px 0' }}
          validate={[vRequired]}
        >
          I agree to pay $10/mth for Call Flow access. I understand that my current call plan will
          stop working and I will need to configure a Call Flow.
        </Field>
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button
            color="tertiary"
            type="submit"
            loading={submitting}
            disabled={!formData.number || !formData.confirmFees || submitting}
          >
            Submit
          </Button>
          <br />
          <br />
          <Button plain onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEnableFlowsForm/NumbersEnableFlowsForm.jsx